import ExplanationOfBusinessValueChain from './ExplanationOfBusinessValueChain';

export default ExplanationOfBusinessValueChain;
